import React from 'react';
import Container from '../../../containers/integration/modules/createModuleContainer';

export default function () {
  return (
    <Container />
  );
}
